module.exports = __webpack_public_path__ + "img/exam-photo.06d1d1f0.png";